<template>
  <div 
    class="grid1-1"
    :style="gridStyles"
  >
    <slot></slot> 
  </div>
</template>

<script>
export default {
  name:'Grid1x1',
  props: {
    msg: String,
    gridStyles:{
      type:Object,
      default:function(){return {}}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid1-1 {
  box-sizing:border-box;
  display: grid;
  min-height:100px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
}
.border {
  border: 1px dashed navy;
}
</style>
